import React from "react"
import {ChromePicker} from "react-color"
import {withStyles} from "@material-ui/core/styles";
import * as Utility from "../components/Utility";

const styles = ({
    color: {
        width: 36,
        height: 14,
        borderRadius: 1,
    },
    swatch: {
        padding: 2,
        background: "#FFFFFF",
        borderRadius: 1,
        boxShadow: "0 0 0 1px rgba(0,0,0,0.1)",
        display: "inline-block",
        cursor: "pointer",
    },
    popover: {
        position: "absolute",
        zIndex: 2,
    },
    cover: {
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
    },
});

class CustomColorPicker extends React.Component {

    /* ------ LIFECYLCE --------*/

    constructor(props) {
        super();

        this.state = {
            displayColorPicker: false,
            color: Utility.convertHexToProperRGB(props.color),
        }
    };

    componentWillReceiveProps = () => {
        this.setState({color: Utility.convertHexToProperRGB(this.props.color)});
    };

    /* ------ HANDLER --------*/

    handleClick = () => {
        this.setState({displayColorPicker: !this.state.displayColorPicker});
    };

    handleClose = () => {
        this.setState({displayColorPicker: false});
    };

    handleOnChangeComplete = color => {
        this.setState({color: color.rgb});
        this.props.onChangeComplete(color);
    };

    /* ------ HTML --------*/

    getColorPicker() {
        const {classes} = this.props;

        let colorPicker = null;
        if (this.state.displayColorPicker) {
            colorPicker = (
                <div className={classes.popover}>
                    <div className={classes.cover} onClick={this.handleClose}/>
                    <ChromePicker
                        color={this.state.color}
                        onChangeComplete={this.handleOnChangeComplete}
                        disableAlpha
                    />
                </div>
            );
        }

        return (
            <div>
                <div className={classes.swatch} onClick={this.handleClick}>
                    <div
                        className={classes.color}
                        style={{
                            backgroundColor: `rgba(
                            ${this.state.color.r},
                            ${this.state.color.g},
                            ${this.state.color.b},
                            ${this.state.color.a}`
                        }}>
                    </div>
                </div>
                {colorPicker}
            </div>
        );
    };

    /* ------ RENDER --------*/

    render() {
        return this.getColorPicker();
    };
}

export default withStyles(styles)(CustomColorPicker);


// WEBPACK FOOTER //
// ./src/components/CustomColorPicker.js